import { renderVenatusAds } from './venatus-ads'
import { TCData } from '../types'
import { updateAnalytics } from './analytics'
import Cookies from 'js-cookie'
import isDevEnvironment from '../util/isDevEnvironment'
import isSupporter from '../util/isSupporter'

interface Window {
	setInterval(callback: () => void, ms: number): number
	__tcfapi?: (
		command: string,
		version: number,
		callback: (tcData: TCData, success: boolean) => void
	) => void
}
declare const window: Window & typeof globalThis

/* eslint-disable @typescript-eslint/no-explicit-any */
declare const googlefc: any

/**
 * Retrigger the consent popup so that the user can update their consent
 */
export default function manageConsent() {
	googlefc.callbackQueue.push({ CONSENT_DATA_READY: () => googlefc.showRevocationMessage() })
}

// Periodically check to see if the TCF API is available, in which case we can
// register a listener for consent changes and update the consent state
//-----------------------------------------------------------------------------
export function setupConsentListener() {
	if (isSupporter()) return

	const tcfCheckInterval = window.setInterval(() => {
		if (window.__tcfapi) {
			window.clearInterval(tcfCheckInterval)
			window.__tcfapi('addEventListener', 2, (_tcData, success) => {
				if (!success) return
				try {
					onConsentData(_tcData)
				} catch (e) {
					if (isDevEnvironment()) console.error('Error handling TCF consent data', e)
				}
			})
		}
	}, 200)

	// Abandon check after 10 seconds
	window.setTimeout(() => {
		window.clearInterval(tcfCheckInterval)
	}, 10000)
}

// Handler for recieving TCFv2 consent data
//-----------------------------------------------------------------------------
let hadExistingConsentSetting = !!Cookies.get('FCCDCF')
function onConsentData(tcData: TCData) {
	if (isDevEnvironment()) {
		console.log('consent', tcData)
	}

	if (!tcData) return

	updateAnalytics(tcData)

	const userDidNotConsent =
		tcData.purpose?.consents && Object.values(tcData.purpose.consents).some(consent => !consent)

	// As of 1 Oct 2025, we will completely stop showing ads where the user has
	// selected "do not consent" and GDPR applies. To hide the ad placements we
	// will add a flag to local storage for the checkShowAds and venatus-ads
	// scripts to use in their computations
	if (tcData.gdprApplies && tcData.purpose?.consents) {
		if (userDidNotConsent) {
			localStorage.setItem('GDPR_DNC_HIDE_ADS', '1')
		} else {
			localStorage.removeItem('GDPR_DNC_HIDE_ADS')
		}
		// force a re-computation of the ad placements
		renderVenatusAds()
	}

	// If the player had an existing consent setting, and has just updated it
	// again, we will want to refresh the page to force the changes into effect
	if (tcData.eventStatus === 'useractioncomplete') {
		if (hadExistingConsentSetting) {
			location.reload()
		} else {
			hadExistingConsentSetting = true
		}
	}
}
